module.exports = {
          srcSet: __webpack_public_path__ + "public/images/869fe1829c748451a99ba943728c8ae6-1774.jpg"+" 1774w",
          images:[ {path: __webpack_public_path__ + "public/images/869fe1829c748451a99ba943728c8ae6-1774.jpg",width: 1774,height: 887}],
          src: __webpack_public_path__ + "public/images/869fe1829c748451a99ba943728c8ae6-1774.jpg",
          toString:function(){return __webpack_public_path__ + "public/images/869fe1829c748451a99ba943728c8ae6-1774.jpg"},
          
          width: 1774,
          height: 887
        }